import { useState, useEffect, useRef } from 'react'

import { EuiButton } from '@equipmentshare/ds2'

import styles from './copyButton.module.css'

export type CopyButtonProps = {
	textToCopy: string,
}

export default function CopyButton( { textToCopy }: CopyButtonProps ) {
	const [ copySuccess, setCopySuccess ] = useState( false )
	const textAreaRef = useRef<HTMLTextAreaElement>( null )

	const label = copySuccess ? 'Copied!' : 'Copy to clipboard'
	const isDisabled = copySuccess

	const onClick = () => {
		navigator.clipboard.writeText( textAreaRef.current?.value ?? '' )
		setCopySuccess( true )
	}

	useEffect( () => {
		let timer: ReturnType<typeof setTimeout> | undefined = undefined

		if ( copySuccess ) {
			timer = setTimeout( () => setCopySuccess( false ), 3000 )
		}

		return timer ? () => clearTimeout( timer ) : undefined
	}, [ copySuccess ] )

	return (
		<>
			<EuiButton
				color="text"
				isDisabled={isDisabled}
				onClick={onClick}
			>
				{label}
			</EuiButton>
			<div className={styles.copyText}>
				<textarea
					ref={textAreaRef}
					value={textToCopy}
					readOnly
				/>
			</div>
		</>
	)
}
